import { deleteEmploymentType } from "../../../../../actions/Utilities/EmploymentType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteEmploymentType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteEmploymentType(ids), {
    onSuccess: (res) => {
      queryClient.invalidateQueries(["GetEmploymentType"]);
      toast.fire(
        "Success",
        "Employment Type were deactivated successfully",
        "success"
      );
    },
    onError: (error) => {
      toast.fire(
        "Bulk deactivation of Employment Type failed",
        "Server Error: Cannot deactivate Employment Type",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteEmploymentType;
